// design-phase-c.md §5/§6 — Quick Add copy. Every new string here is
// checked against design-spec-today-card.md §4's banned list (manager,
// role, permission, assignment, cadence, parent/child, delegate/
// delegation, token, session, magic link) — "task"/"chore"/"health
// note"/"weight" are this app's own already-governed nouns (recordsCopy.ts
// §6/§10, calendarCopy.ts), reused verbatim, never re-invented here.

export type QuickAddAction = "task" | "health-note" | "weight" | "chore";

export const QUICK_ADD_BUTTON_LABEL = "+ Quick add";
export const QUICK_ADD_FAB_LABEL = "Quick add";
export const QUICK_ADD_MENU_HEADING = "Quick add";
export const QUICK_ADD_ANIMAL_PICKER_TITLE = "Which animal?";

// R-C0b-3 (RESOLVED) — dropped "Where (optional)," a field
// `CalendarCreateSheet` never actually has (already flagged/cut in Phase
// B, TD-007). m-C0b-8 (confirmed, not an unflagged drift) — one word
// shorter than `calendarCopy.ts::createSheetTitle`'s "Add a one-time task
// for <date>" template: Quick Add's task is inherently one-time by
// construction, so "one-time" is redundant here specifically.
export const QUICK_ADD_TASK_SHEET_TITLE = "Add a task for today";

export const QUICK_ADD_ROW_LABEL_BY_ACTION: Record<QuickAddAction, string> = {
  task: "＋ Add a task",
  "health-note": "＋ Log a health note",
  weight: "＋ Log a weight",
  chore: "＋ Add a chore",
};
